import { Shark } from "shark-mvc";

import ManagerBase from "./ManagerBase";

class CustomTagsCategoryManager extends ManagerBase {
	constructor () {
		super("customTagsCategoryManager");
		this.remoteClassName = "custom-tags-category";
	}
}

const customTagsCategoryManager = new CustomTagsCategoryManager();

Shark.registerController(customTagsCategoryManager);

export default customTagsCategoryManager;
